import { Box, Typography } from "@mui/material";
import { appConfig } from "../../utils/config";
import { useTranslation } from "react-i18next";
import "./Footer.css";

const FOOTER_LINKS_BY_CLIENT = {
  CLIENT_B: {
    legal: "https://www.navarra.es/es/aviso-legal",
    cookies: "https://www.navarra.es/es/proteccion-de-datos",
  },
  CLIENT_C: {
    legal: "https://www.caib.es/webgoib/es/aviso-legal",
    cookies: "https://www.caib.es/webgoib/es/politica-de-cookies",
  },
};

const Footer = () => {
  const { t } = useTranslation();
  const textColor = appConfig.client === "CLIENT_B" ? "black" : "white";
  const clientFooterLinks = FOOTER_LINKS_BY_CLIENT[appConfig.client];

  const footerLinks = [
    { label: t("legalPolicy"), to: clientFooterLinks?.legal },
    {
      label: t("cookiesPolicy"),
      to: clientFooterLinks?.cookies,
    },
  ];

  const renderFooterLink = ({ label, to }) =>
    to ? (
      <a href={to} className="footer-link" target="_blank" rel="noreferrer">
        <Typography sx={{ color: textColor }}>{label}</Typography>
      </a>
    ) : (
      <span className="footer-link">
        <Typography sx={{ color: textColor }}>{label}</Typography>
      </span>
    );

  return (
    <Box className="footer-container">
      <Box className="footer-links">
        {renderFooterLink(footerLinks[0])}
        <Typography className="footer-separator" sx={{ color: textColor }}>
          |
        </Typography>
        {renderFooterLink(footerLinks[1])}
      </Box>

      <Box className="footer-logos">
        {appConfig.logoSecondary && (
          <img
            src={appConfig.logoSecondary}
            alt="Secondary Logo"
            className="footer-logo secondary"
          />
        )}
        {appConfig.logoThird && (
          <img
            src={appConfig.logoThird}
            alt="Third Logo"
            className="footer-logo third"
          />
        )}
        {appConfig.logoFourth &&
          appConfig.client !== "CLIENT_B" &&
          appConfig.client !== "CLIENT_C" && (
          <img
            src={appConfig.logoFourth}
            alt="Fourth Logo"
            className="footer-logo fourth"
          />
        )}
        <img
          src={appConfig.logo}
          alt="Main Logo"
          className={`footer-logo main ${
            appConfig.client !== "CLIENT_B" ? "client-other" : ""
          }`}
        />
      </Box>
    </Box>
  );
};

export default Footer;
